import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";


export default class NavsFull {
    static init() {
        this.header = document.querySelector(".header-main-burger");

        if (this.header) {
            this.toggleMobileNav();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    static toggleMobileNav() {
        const openTrigger = document.querySelector(".nav-main-toggle");
        if (openTrigger) {
            openTrigger.addEventListener("click", () => {
                if (document.body.classList.contains("navs-open")) {
                    this.closeNav();
                } else {
                    this.openNav();
                }
            });
        }

        const lev1Parents = this.header.querySelectorAll(".nav-main .menu-item-lev1.menu-item-has-children");
        lev1Parents.forEach(link => {
            const target = link.querySelector("a.target");
            const subnav = link.querySelector(".lev2");

            // subnav.dataset.height = subnav.clientHeight;
            // subnav.style.height = 0;

            target.addEventListener("click", (e) => {
                if (window.innerWidth <= 991 || document.querySelector('.header-main-full.force-burger-mode')) {
                    e.preventDefault();

                    if (!link.classList.contains("active")) {
                        link.classList.add("active");
                        if( subnav ) {
                            subnav.classList.add("show");
                        }
                        // gsap.to(subnav, {
                        //     height: subnav.dataset.height,
                        //     duration: 0.3
                        // });
                    } else {
                        link.classList.remove("active");
                        if( subnav ) {
                            subnav.classList.remove("show");
                        }
                        // gsap.to(subnav, {
                        //     height: 0,
                        //     duration: 0.3
                        // });
                    }
                }
            });
        });
    }

    static openNav() {
        if (Header.isProjectArchive()) {
            Header.closeFilterPanel();
        }

        document.body.classList.add("navs-open");
        Header.makeHeaderAsBannerTheme();

        // GlobalVariables.lenis?.stop();
    }

    static closeNav() {
        document.body.classList.remove("navs-open");
        Header.restoreHeaderTheme();

        // GlobalVariables.lenis?.start();
    }

    static resize() {
        this.closeNav();
    }
}
